import { useContext } from 'react';
import { ContextoAutenticacao, ValoresContextoAutenticacao } from './authContext';

export const useAutenticacao = (): ValoresContextoAutenticacao => {
  const contexto = useContext(ContextoAutenticacao);
  if (contexto === undefined) {
    throw new Error('useAutenticacao deve ser usado dentro de um ProvedorAutenticacao. Certifique-se de que o componente está envolvido pelo ProvedorAutenticacao no App.tsx');
  }
  return contexto;
};